import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RestService } from '../../services/rest.service';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gpt-popup',
  templateUrl: './gpt-popup.component.html',
  styleUrls: ['./gpt-popup.component.css']
})
export class GptPopupComponent implements OnInit {
  description: string = '';
  id: number = 0;
  loading: boolean;
  gptForm: FormGroup;
  isLoading: boolean;
  submitted = false;
  command: string = '';
  input: any;


  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private toastr: ToastrService,
    private activeModel: NgbActiveModal,
    private toaster: ToastrService,) { }

  ngOnInit() {
    this.buildForm();
  }
  onInsertClick() {
    this.activeModel.close(this.description);
  }


  close() {
    this.activeModel.close(false);
    this.loading = false;

  }
  get f() { return this.gptForm.controls };
  buildForm() {
    this.gptForm = this.fb.group({
      id: new FormControl(0),
      description: new FormControl(this.description || '', Validators.compose([Validators.maxLength(500), Validators.min(0)])),

    });
  }

  genratefromAI() {
    this.loading = true;
    this.restService.post(
      `${environment.urls.WorkOrder_ExtractOpenAIDescription}?input=${this.input}&command=${this.command}`,
      {}
    ).subscribe(
      (resp) => {
        this.loading = false;
        if (resp) {
          let extractedText = '';

          if (resp.result && typeof resp.result === 'string') {
            extractedText = resp.result;

            if (extractedText.includes('Assistant:')) {
              extractedText = extractedText.split('Assistant:')[1].trim();
            }
          } else if (resp.description) {
            extractedText = resp.description;
          } else {
            extractedText = "AI generated suggestion unavailable.";
          }

          this.description = extractedText;
          this.isLoading = false;
        }
      },
      (error) => {
        this.loading = false;
        this.isLoading = false;
        this.toaster.error('Error processing AI description.', 'Error');
      }
    );
  }
}
